import {Button, Flex, FormInstance} from 'antd';
import {ReactElement} from 'react';
import {generatePath} from 'react-router';

import {appRoute} from '../../../../../app-route';
import {Meta} from '../../../../../component/meta/meta';
import {Text} from '../../../../../component/text/text';
import {spacer_m} from '../../../../../css/var-export.scss';
import {BreadCrumbs} from '../../../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../../../layout/page/page';
import {MainPageContainer} from '../../../../../layout/page-card/main-page-card';
import {PageCard} from '../../../../../layout/page-card/page-card';
import {PageHeader} from '../../../../../layout/page-header/page-header';
import {Locale} from '../../../../../provider/locale/localization';
import {useGoBackHook} from '../../../../../service/navigation/go-back-hook';
import {ReviewFormErrorType} from '../../../../../service/reviews/custom-reviews';
import {ReviewCustomCompanyType} from '../../../../../service/reviews/reviews-custom-compamies';
import {CustomReviewFormFields} from '../../review-form/custom-review-form-fields';
import {ReviewFormFieldsType} from '../../review-form/review-form-type';

type PropsType = {
    pageHeaderTitle: string;
    form: FormInstance<ReviewFormFieldsType>;
    serverError: ReviewFormErrorType | null;
    handleSubmit: () => void;
    isReviewFormInProgress: boolean;
    handleCancel: () => void;
    initialCompany?: ReviewCustomCompanyType | null;
    initialValues?: ReviewFormFieldsType;
    authorInfo?: string | null;
    editReview?: number;
};

export function CustomReviewForm(props: PropsType): ReactElement {
    const {
        pageHeaderTitle,
        form,
        handleCancel,
        serverError,
        isReviewFormInProgress,
        handleSubmit,
        initialValues,
        initialCompany,
        authorInfo,
        editReview,
    } = props;

    const goBack = useGoBackHook(appRoute.reviewsManagement.path);

    return (
        <Page isTopFilterHidden renderContainer={(children) => <MainPageContainer>{children}</MainPageContainer>}>
            <Meta title={pageHeaderTitle} />
            <PageCard>
                <BreadCrumbs
                    list={[
                        {path: appRoute.reviewsManagement.path, titleLangKey: 'CATEGORY_NAME__REVIEWS'},
                        {
                            path: editReview
                                ? generatePath(appRoute.reviewsManagementEditReview.path, {reviewId: editReview})
                                : appRoute.reviewsManagementCreateReview.path,
                            title: pageHeaderTitle,
                        },
                    ]}
                />

                <PageHeader>
                    {pageHeaderTitle}
                    <Button onClick={goBack}>
                        <Text stringKey="BUTTON__BACK" />
                    </Button>
                </PageHeader>
            </PageCard>
            <CustomReviewFormFields
                authorInfo={authorInfo}
                editReview={editReview}
                form={form}
                initialCompany={initialCompany}
                initialValues={initialValues}
                serverError={serverError}
            />
            <PageCard>
                <Flex gap={spacer_m}>
                    <Button
                        disabled={isReviewFormInProgress}
                        loading={isReviewFormInProgress}
                        onClick={handleSubmit}
                        type="primary"
                    >
                        <Locale stringKey="BUTTON__SAVE" />
                    </Button>
                    <Button onClick={handleCancel}>
                        <Locale stringKey="BUTTON__CANCEL" />
                    </Button>
                </Flex>
            </PageCard>
        </Page>
    );
}
